import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
    const edgeColor = '#DDD';

    return {
        netGraph: {
            display: 'block',
            fontFamily: 'Roboto, Helvetica, Arial, Verdana, sans-serif',

            '& > svg': {
                '&:active': {
                    cursor: 'all-scroll',
                },

                width: '100%',
                display: 'block',
            },

            '& .graph-node': {
                cursor: 'default',

                '&.hover-enabled': {
                    cursor: 'pointer',
                },

                '& .node-outline': {
                    fill: edgeColor,
                    stroke: theme.palette.background.paper,
                    strokeWidth: 4,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    fontSize: 24,

                    '&.npoint-icon, &.server-icon, &.disjoint-icon': {
                        fill: theme.palette.background.paper,
                    },

                    '&.router-icon': {
                        strokeWidth: 0,
                        fontSize: 32,
                    },
                },

                '& .node-icon': {
                    strokeWidth: 0,
                    fontSize: 24,
                    fill: edgeColor,

                    '&.npoint-icon, &.server-icon': {
                        fill: theme.palette.text.primary,
                    },
                },

                '& .router-icon': {
                    fontSize: 32,
                },
            },

            '& .graph-edge': {
                fill: 'none',
                stroke: edgeColor,
                strokeWidth: 8,

                '&.hidden-edge': {
                    stroke: 'transparent',
                },

                '&.highlight': {
                    strokeWidth: 3,
                },
            },

            '& .npoint-labels, .server-labels, .router-labels, .disjoint-labels': {
                '& tspan': {
                    fontSize: 14,
                    fill: theme.palette.text.primary,
                },
            },

            '& .graph-metric-value': {
                fontSize: 30,
                fontWeight: 'bold',
                fill: theme.palette.text.primary,
            },

            '& .graph-metric-title': {
                fontSize: 14,
                fill: theme.palette.text.primary,
            },
        },
    };
});

export default useStyles;
